import { Campaign } from './campaign';
import { Placement } from '../../(inventory)/types/placement';
import { Creative } from './creative';
import { Site } from '../../(inventory)/types/site';

/**
 * Order = Line item
 * @doc: https://support.google.com/admanager/answer/82991
 */
export enum OrderStatus {
    'DRAFT' = 'DRAFT', // Line item is part of an order that has not been approved.
    'PENDING_APPROVAL' = 'PENDING_APPROVAL', // Requires approval from account administrator to deliver.
    'DISAPPROVED' = 'DISAPPROVED', // Line item was disapproved by an account administrator.
    'INACTIVE' = 'INACTIVE',
    'READY' = 'READY',
    'NEEDS_CREATIVES' = 'NEEDS_CREATIVES',
    'DELIVERING' = 'DELIVERING',
    'DELIVERY_EXTENDED' = 'DELIVERY_EXTENDED',
    'PAUSED' = 'PAUSED',
    'COMPLETED' = 'COMPLETED',
    'ARCHIVED' = 'ARCHIVED',
}

export enum AdType {
    DISPLAY = 'DISPLAY',
    AUDIO = 'AUDIO',
    VIDEO = 'VIDEO',
}

export enum PricingModel {
    'CPM' = 'CPM', // Custo por mil impressões
    'CPC' = 'CPC', // Custo por clique
    'CPV' = 'CPV', // Custo por visualização
}

export interface Order {
    id: number;
    campaignId?: number | null;
    campaign?: Campaign | null;
    siteId?: number | null;
    site?: Site | null;
    startDate: string;
    endDate: string;
    adType: AdType;
    status: OrderStatus[];
    segmentation: string;
    creativeLine: string;
    viewability: number;
    placementId?: number | null;
    placement?: Placement | null;
    sizes: string[];
    pricingModel: PricingModel;
    maxMediaDurationInSeconds: number | null;
    impressions: number;
    deliveryImpressions: number;
    clickTag: string | null;
    creativeId?: number | null;
    creative?: Creative | null;
    gamOrderId?: string | null;
    gamLineItemId?: string | null;
    createdAt: Date;
    updatedAt: Date | null;
}

export type AddOrder = Omit<Order, 'id' | 'status' | 'deliveryImpressions' | 'createdAt' | 'updatedAt'>;
